<template>
  <div class="history-modal">
    <HistList :list="normalizedList" :model-name="modelName" :model-id="modelId" ref="listRef" />

    <div class="d-flex justify-content-center mt-3 mb-3">
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="$emit('modalstack:close', false)"
      >
        ОК
      </button>
    </div>
  </div>
</template>
<script setup>
import HistList from '@/components/history/list.vue'
import { computed, toValue, ref } from 'vue'
defineEmits(['modalstack:close'])
const props = defineProps({
  list: {
    type: [Object, Array],
    default: () => [],
  },
  modelName: String,
  modelId: Number,
})
const listRef = ref()
defineExpose({
  listRef,
})
const normalizedList = computed(() => {
  const val = toValue(props.list)
  if (Array.isArray(val)) return val
  if (val?.data && Array.isArray(val.data)) return val.data
  return val
})
</script>
